<template>
  <v-container class="pa-4 pt-1" fluid>
    <v-card class="pa-6">
      <!-- <v-card class="ma-5" elevation="0"> -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Patent Matter</v-card-title>
        </v-col>

        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-btn to="/new-master-patent" color="#0A7EA5" rounded dark class="mb-2" :disabled="!authorize_add">
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-row class="align-start">
            <v-col cols="12" md="7">
              <v-text-field v-model="search_pt" outlined dense label="Search"
                v-on:keyup.enter="onSearchPagination"></v-text-field>
              <h4 class="text-danger red--text mt-n8">
                * input text and enter for search
              </h4>
            </v-col>

            <v-col cols="12" md="5" class="d-flex align-start">
              <v-autocomplete clearable @click:clear="
                $nextTick(() => {
                  master_status = 0;
                })
                " v-model="master_status" :items="patent_status_list" item-text="patent_status_name"
                item-value="patent_status_id" outlined dense label="Status" style="width: 250px"
                @change="onSearchPagination"></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6" class="d-flex justify-end mt-n6">
          <v-row>
            <v-col cols="12" md="3" class="d-flex justify-center align-center" offset="1">
              Next Annuity Date :
            </v-col>

            <v-col cols="12" md="4">
              From
              <v-menu v-model="menuadddatefrom" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290" max-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="searchdatefrom" clearable @click:clear="
                    $nextTick(() => {
                      searchdatefromS = null;
                      searchdatefrom = null;
                      searchdateto = null;
                      searchdatetoPicker = null;
                      onSearchPagination();
                    })
                    " persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="onSearchPagination"
                    append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense readonly></v-text-field>
                </template>

                <v-date-picker v-model="searchdatefromPicker" @input="
                  () => {
                    searchdatefrom =
                      formatDateToDDMMYYYY(searchdatefromPicker);
                    menuadddatefrom = false;
                    onSearchPagination();
                  }
                "></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              To
              <v-menu v-model="menuadddateto" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290" max-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field clearable @click:clear="
                    $nextTick(() => {
                      searchdatefromS = null;
                      searchdatefrom = null;
                      searchdateto = null;
                      searchdatetoPicker = null;
                      onSearchPagination();
                    })
                    " v-model="searchdateto" persistent-hint hint="Format DD/MM/YYYY"
                    @keydown.enter="onSearchPagination" append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined
                    dense readonly></v-text-field>
                </template>

                <v-date-picker v-model="searchdatetoPicker" @input="
                  () => {
                    searchdateto = formatDateToDDMMYYYY(searchdatetoPicker);
                    menuadddateto = false;
                    onSearchPagination();
                  }
                "></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <br />
      <v-card outlined tile>
        <!-- <v-data-table
          :items-per-page-options="pageSizes"
          :page.sync="page"
          :items-per-page="100"
          @page-count="pageCount = $event"
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 100, -1],
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
              @click="openeditItem(item.masterpt_id)"
              v-if="authorize_edit"
            >
              mdi-pencil
            </v-icon>

            <span
              v-if="authorize_add && item.status == 'Closed'"
              @click="
                openeAppoinmentOperationforClosed(
                  item.file_no,
                  item.masterpt_id
                )
              "
              class="v-icon ml-1"
              :style="{
                cursor: 'pointer',
                width: '24px',
                height: '24px',
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
            >
              <v-img
                src="@/assets/Reopen_icon.png"
                alt="restore"
                style="width: 100%; height: 100%; object-fit: cover;"
              />
            </span>

            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#dbd7d0',
                color: '#6E6658',
              }"
              @click="openeAppoinmentOperation(item.file_no)"
              v-if="authorize_add && item.status !== 'Closed'"
            >
              mdi-calendar-plus
            </v-icon>
            <v-icon
              v-if="item.appointment_refno != 0"
              class="ml-1"
              :style="{
                backgroundColor: '#d7dee0',
                color: '#183981',
              }"
              @click="loadTimeline(item.masterpt_id, item.file_no)"
            >
              mdi-calendar-check
            </v-icon>
            <v-icon
              :style="{
                backgroundColor: '#CCE7D8',
                color: '#11733D',
              }"
              @click="openPrintAppNo(item)"
            >
              mdi-printer
            </v-icon>
          </template>
        </v-data-table>
        <v-progress-linear
          indeterminate
          color="teal"
          v-if="load_bg"
        ></v-progress-linear> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
            label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="totalItems"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon class="ml-1" :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }" @click="openeditItem(item.masterpt_id)" v-if="authorize_edit">
                mdi-pencil
              </v-icon>

              <span v-if="authorize_add && item.status_show == 'Closed'" @click="
                openeAppoinmentOperationforClosed(
                  item.file_no,
                  item.masterpt_id
                )
                " class="v-icon ml-1" :style="{
                  cursor: 'pointer',
                  width: '24px',
                  height: '24px',
                  backgroundColor: '#E1F5FE',
                  color: '#254E58',
                }">
                <v-img src="@/assets/Reopen_icon.png" alt="restore"
                  style="width: 100%; height: 100%; object-fit: cover" />
              </span>

              <v-icon class="ml-1" :style="{
                backgroundColor: '#dbd7d0',
                color: '#6E6658',
              }" @click="openeAppoinmentOperation(item.file_no)" v-if="authorize_add && item.status_show != 'Closed'">
                mdi-calendar-plus
              </v-icon>
              <v-icon v-if="item.appointment_refno != 0" class="ml-1" :style="{
                backgroundColor: '#d7dee0',
                color: '#183981',
              }" @click="loadTimeline(item.masterpt_id, item.file_no)">
                mdi-calendar-check
              </v-icon>
              <v-icon :style="{
                backgroundColor: '#CCE7D8',
                color: '#11733D',
              }" @click="openPrintAppNo(item)">
                mdi-printer
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-card>
    <!-- </v-card> -->
    <v-dialog v-model="dialogShow" max-width="1200px">
      <v-card class="pr-6 pl-6 pt-6 pb-0">
        <v-card-title>
          <v-row>
            <v-col md="6">
              <span class="text-h5">Appointment For Patent {{ ShowfileNO }}</span>
            </v-col>
            <v-col md="6" class="d-flex justify-end heightsizeformadvance">
              <v-icon large @click="closedialogShow()" color="#254E58">
                mdi mdi-close
              </v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table :items-per-page-options="pageSizes" :page.sync="page" :items-per-page="itemsPerPage"
              @page-count="pageCount = $event" :headers="headerspopup" :items="mDataArraypopup" class="elevation-1"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
              }">
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon :style="{
                  backgroundColor: '#E1F5FE',
                  color: '#2196F3',
                }" @click="openeditTableAppointment(item.appointment_id)">
                  mdi-pencil
                </v-icon>
              </template>
            </v-data-table></v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogtimeline" max-width="1200px">
      <v-card class="pr-6 pl-6 pt-6 pb-0">
        <v-card-title>
          <v-row>
            <v-col md="6">
              <span class="text-h5">Matter Timeline All Docket For {{ ShowfileNO }}</span>
            </v-col>
            <v-col md="6" class="d-flex justify-end heightsizeformadvance">
              <v-icon large @click="dialogtimeline = false" color="#254E58">
                mdi mdi-close
              </v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row>
          <v-col cols="12" md="12" style="margin: auto">
            <v-timeline dense>
              <v-timeline-item v-for="item in showtimelineData" :key="item.id" color="primary" small>
                <v-card class="pa-3">
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <div>{{ item.show_date }}</div>
                      <br />
                      <div style="margin-top: -20px">
                        {{
                          item.documenttype_code ? item.documenttype_code : ""
                        }}
                      </div>
                      <!-- {{ JSON.parse(item.documenttype_actions)[0]?JSON.parse(item.documenttype_actions)[0].documenttype_code:"" }} -->
                      <div v-for="datadocumenttype_actions in (item.documenttype_actions || [])"
                        :key="datadocumenttype_actions.id" style="font-size: 0.8rem; color: gray">
                        - {{ datadocumenttype_actions.name }}
                      </div>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <v-row style="margin-top: -10px">
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="
                              item.fullnameen_user_update ||
                              item.fullnameth_user_update
                            ">Last Updated {{ item.updated_date }}</span>
                            <span v-else>Last Updated -</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="
                              item.fullnameen_user_update ||
                              item.fullnameth_user_update
                            ">Last Update By
                              {{
                                item.fullnameen_user_update
                                  ? item.fullnameen_user_update
                                  : item.fullnameth_user_update
                                    ? item.fullnameth_user_update
                                    : ""
                              }}</span>
                            <span v-else>Last Update By -</span>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: -25px">
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="item.created_date">Created Date {{ item.created_date }}</span>
                            <span v-else>Created Date -</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="
                              item.fullnameen_user_create ||
                              item.fullnameth_user_create
                            ">Create By
                              {{
                                item.fullnameen_user_create
                                  ? item.fullnameen_user_create
                                  : item.fullnameth_user_create
                                    ? item.fullnameth_user_create
                                    : ""
                              }}</span>
                            <span v-else>Create By -</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-center">
                      <template>
                        <v-btn icon outlined color="primary" small @click="editItemtimeline(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                    </v-col>
                  </v-row>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <template>
      <page size="A4" class="aligncenter" id="mydivhtmltobase" :style="showprint">
        <div class="aligncenter">
          <div class="rowprpo mr30prpo mt30">
            <!-- <div class="col-md-8report"></div>
              <div class="col-md-4report">
                <h5 class="alignright colprpo ">
                  No :
                </h5>
              </div> -->
          </div>
          <div class="rowprpo aligncenter">
            <div class="col-md-12report mb-50 wordspacingsummary">
              <h2>Patent Matter</h2>
            </div>
          </div>
          <div class="rowprpo ml95prpo mr95prpo col-md-12report">
            <h4>I. &nbsp;&nbsp;&nbsp; Correspondence and references</h4>
          </div>

          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-3report textalignleft fontsize13">
                  Our Ref. :
                </div>
                <div v-if="print_data.file_no != ''"
                  class="col-md-8report textalignleft ml10-prpo fixonerow showdefaultunderline">
                  {{ print_data.file_no }}
                </div>
                <div v-else class="col-md-8report textalignleft ml10-prpo fixonerow">
                  -
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-2report textalignleft fontsize13">
                  Agent Ref.:
                </div>
                <div class="col-md-9report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>

          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-3report textalignleft fontsize13">
                  Applicant:
                </div>
                <div class="col-md-8report textalignleft ml10-prpo fixonerow">
                  -
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-2report textalignleft fontsize13">
                  Agent:
                </div>
                <div v-if="print_data.agent_n" class="col-md-9report textalignleft fixonerow showdefaultunderline">
                  {{ print_data.agent_n }}
                </div>
                <div v-else class="col-md-9report textalignleft fixonerow">
                  -
                </div>
              </div>
            </div>
          </div>

          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fixfourrow">
                  Applicant's Address: &nbsp;
                  <span class=""> - </span>
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  Agent's Address:
                </div>
                <div v-if="print_data.agent_a" class="col-md-8report textalignleft showdefaultunderline">
                  {{ print_data.agent_a }}
                </div>
                <div v-else class="col-md-8report textalignleft">-</div>
              </div>
            </div>
          </div>
          <br />
          <div class="rowprpo ml95prpo mr95prpo col-md-12report">
            <h4>II. &nbsp;&nbsp;Type of Patent</h4>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 15px">
            <div class="col-md-11report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-3report textalignleft fontsize13">
                  <span>
                    <input type="checkbox" v-if="print_data.type == 2" checked />
                    <input type="checkbox" v-else />
                    &nbsp;INVENTION
                  </span>
                </div>
                <div class="col-md-3report textalignleft fontsize13">
                  <span>
                    <input type="checkbox" v-if="print_data.type == 1" checked />
                    <input type="checkbox" v-else />
                    &nbsp;PRODUCT DESIGN
                  </span>
                </div>
                <div class="col-md-3report textalignleft fontsize13">
                  <span>
                    <input type="checkbox" v-if="print_data.type == 3" checked />
                    <input type="checkbox" v-else />
                    &nbsp;PETTY PATENT
                  </span>
                </div>
                <div class="col-md-3report textalignleft fontsize13">
                  <span>
                    <input type="checkbox" v-if="print_data.type == 4" checked />
                    <input type="checkbox" v-else />
                    &nbsp;INVENTION/PCT
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 15px">
            <div class="col-md-11report">
              <div class="rowprpo" style="margin-left: 93px">
                <div v-if="print_data.title" class="col-md-11report textalignleft fontsize13">
                  TITLE :
                  <b><u>{{ print_data.title }}</u></b>
                </div>
                <div v-else class="col-md-9report textalignleft fixonerow">
                  TITLE : -
                </div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-5report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Application No.
                </div>
                &nbsp;
                <div v-if="print_data.app_no"
                  class="col-md-6report textalignleft ml20-prpo fixonerow showdefaultunderline">
                  {{ print_data.app_no }}
                </div>
                <div v-else class="col-md-6report textalignleft ml20-prpo fixonerow">
                  -
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-2report textalignleft fontsize13">
                  Filing Date
                </div>
                <div class="col-md-9report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>

          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 5px">
            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-5report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Publication Vol.
                </div>
                <div class="col-md-6report textalignleft ml20-prpo fixonerow">
                  -
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  Publication Date
                </div>
                <div v-if="print_data.date_of_publishing_f"
                  class="col-md-8report textalignleft fixonerow showdefaultunderline">
                  {{ print_data.date_of_publishing_f }}
                </div>
                <div v-else class="col-md-8report textalignleft fixonerow">
                  -
                </div>
              </div>
            </div>
          </div>

          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 5px">
            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-5report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Registration No.
                </div>
                &nbsp;
                <div v-if="print_data.patent_no"
                  class="col-md-6report textalignleft ml20-prpo fixonerow showdefaultunderline">
                  {{ print_data.patent_no }}
                </div>
                <div v-else class="col-md-6report textalignleft ml20-prpo fixonerow">
                  -
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  Registration Date
                </div>
                &nbsp;
                <div v-if="print_data.date_of_patent_f"
                  class="col-md-8report textalignleft fixonerow showdefaultunderline">
                  {{ print_data.date_of_patent_f }}
                </div>
                <div v-else class="col-md-8report textalignleft fixonerow">
                  -
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="rowprpo ml95prpo mr95prpo col-md-12report">
            <h4>III. &nbsp;Priority Details</h4>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13">
                  <input type="checkbox" />&nbsp; Paris Convertion
                </div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-2report textalignleft fontsize13">
                  Priority Date:
                </div>
                <div class="col-md-8report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13"></div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  Country/Priority No:
                </div>
                <div class="col-md-8report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13">
                  <input type="checkbox" />&nbsp; PCT
                </div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-2report textalignleft fontsize13">
                  Priority Date:
                </div>
                <div class="col-md-9report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13"></div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  Country/Priority No:
                </div>
                <div class="col-md-8report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13"></div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  Internation Filing Date:
                </div>
                &nbsp;
                <div class="col-md-8report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13"></div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13">
                  International Filing No:
                </div>
                &nbsp;
                <div class="col-md-8report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;PCT
                </div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-2report textalignleft fontsize13">
                  Priority Date:
                </div>
                <div class="col-md-9report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 5px">
            <div class="col-md-4report">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-12report textalignleft fontsize13">
                  <input type="checkbox" />&nbsp; No Priority Claim
                </div>
              </div>
            </div>

            <div class="col-md-8report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-3report textalignleft fontsize13"></div>
                <div class="col-md-8report textalignleft fixonerow"></div>
              </div>
            </div>
          </div>
          <br />
          <div class="rowprpo ml95prpo mr95prpo col-md-12report">
            <h4>IV. &nbsp;&nbsp;Prosecution</h4>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Opposition/Counter Statement
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Request for substantive
                  Examination
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Submission of the examination
                  report
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Amendment
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Appeal to the Patent Commitee
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Court case
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <br />
          <div class="rowprpo ml95prpo mr95prpo col-md-12report">
            <h4>V. &nbsp; &nbsp;&nbsp;Maintenance</h4>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 10px">
            <div class="col-md-6report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div class="col-md-11report textalignleft fontsize13">
                  <input type="checkbox" /> &nbsp;Annuity Fee
                </div>
              </div>
            </div>

            <div class="col-md-6report">
              <div class="rowprpo" style="margin-left: 20px">
                <div class="col-md-1report textalignleft fontsize13">Date:</div>
                <div class="col-md-10report textalignleft fixonerow">-</div>
              </div>
            </div>
          </div>
          <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13" style="margin-top: 2px">
            <div class="col-md-12report mt-3">
              <div class="rowprpo" style="margin-left: 93px">
                <div v-if="print_data.remark" class="col-md-11report textalignleft fontsize13">
                  Remarks:
                  <b><u>{{ print_data.remark }}</u></b>
                </div>
                <div v-else class="col-md-11report textalignleft fontsize13">
                  Remarks: -
                </div>
              </div>
            </div>
          </div>
        </div>
      </page>

      <v-dialog v-model="dialogAppoinmentOperationforClosed" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to update status this Item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAppoinmentOperationforClosed = false">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="AppoinmentOperationforClosedconfirmstatus()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";
import pdfvuer from "pdfvuer";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";
export default {
  name: "MasterPatent",
  async mounted() {
    this.$showLoader();
    await api.checkVersion();

    // ----------------- Check Authorize ---------------------------
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    if (this.authorize_id == null || this.authorize_id == 0) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
      return; // ป้องกันไม่ให้ทำงานต่อ
    }

    const router_path = parser.pathname.replace("/", "");
    // console.log("router_path:" + router_path);

    try {
      const res_auth = await api.getAuthorize(this.userId, router_path);

      this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
      this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
      this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
      this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

      // ลบบรรทัดนี้ออก - เป็นสาเหตุที่ดีดออกไปหน้าอื่น
      // this.$router.back();

      if (this.userId && api.isLoggedIn()) {
        // OK to continue
      } else {
        this.$store.state.isLogged = false;
        this.$router.push("/login");
        return;
      }

      if (!this.authorize_view) {
        this.$router.push("/not-found");
        return;
      }

      // โหลดข้อมูลหลังจากตรวจสอบ authorize เสร็จแล้ว
      // await this.loaddataPagination();
    } catch (error) {
      console.error("Authorization check failed:", error);
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Error",
        "Failed to check authorization",
        "text-h5 red--text text-center"
      );
    } finally {
      this.$hideLoader();
    }
  },
  components: { SuccessDialog, SuccessDialogPush },
  data(vm) {
    const today = new Date();
    const todayStr = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const plus30 = new Date();
    plus30.setDate(today.getDate() + 30);
    const plus30Str = `${String(plus30.getDate()).padStart(2, "0")}/${String(
      plus30.getMonth() + 1
    ).padStart(2, "0")}/${plus30.getFullYear()}`;

    // แปลง DD/MM/YYYY เป็น YYYY-MM-DD สำหรับ DatePicker
    const toYMD = (ddmmyyyy) => {
      const [dd, mm, yyyy] = ddmmyyyy.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      menuadddatefrom: false,
      searchdatefrom: todayStr,
      searchdatefromPicker: toYMD(todayStr),
      menuadddateto: false,
      searchdateto: plus30Str,
      searchdatetoPicker: toYMD(plus30Str),

      tableLoading: false,
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      dataupdatestatusmasterpt_id: 0,
      dialogAppoinmentOperationforClosed: false,
      showtimelineData: [],
      dialogtimeline: false,
      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      // itemsPerPage: 100,
      load_bg: false,
      isShowPassword: false,
      fullPage: true,
      search: "",
      mDataArray: [],
      mDataArraypopup: [],
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogShow: false,
      ShowfileNO: "",
      search_pt: "",
      headers: [
        {
          text: "Object Types",
          value: "objecttype_show",
          class: "bg-colorth",
          divider: true,
          width: "130px",
        },
        {
          text: "File No.",
          value: "file_no",
          class: "bg-colorth",
          divider: true,
          width: "105px",
        },
        {
          text: "Application No.",
          value: "app_no",
          class: "bg-colorth",
          divider: true,
          width: "140px",
        },
        {
          text: "Country",
          value: "city",
          class: "bg-colorth",
          divider: true,
          width: "140px",
        },
        {
          text: "Patent No.",
          value: "patent_no",
          class: "bg-colorth",
          divider: true,
          width: "110px",
        },
        // {
        //   text: "Client Ref.",
        //   value: "client_ref",
        //   class: "bg-colorth",
        //   divider: true,
        //   width: "140px",
        // },
        // {
        //   text: "Client Name",
        //   value: "name_of_client",
        //   class: "bg-colorth",
        //   divider: true,
        //   width: "140px",
        // },
        {
          text: "Status",
          value: "status_show",
          class: "bg-colorth",
          divider: true,
          width: "8%",
        },

        {
          text: "Client",
          value: "name_of_client",
          class: "bg-colorth",
          divider: true,
          width: "120px",
        },
        {
          text: "Agent Reference",
          value: "client_ref",
          class: "bg-colorth",
          divider: true,
          width: "140px",
        },
        {
          text: "Agent",
          value: "agent",
          class: "bg-colorth",
          divider: true,
          width: "120px",
        },
        {
          text: "Associate",
          value: "associate",
          class: "bg-colorth",
          divider: true,
          width: "130px",
        },
        {
          text: "Next Annuity Date",
          value: "next_annuity_date",
          class: "bg-colorth",
          divider: true,
          width: "150px",
        },
        {
          text: "Manage",
          value: "actions",
          width: "150px",
          align: "left",
          divider: true,
          sortable: false,
        },
      ],
      headerspopup: [
        {
          text: "Work Type",
          value: "documenttype_code",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "File No.",
          value: "refno",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "Client Name",
          value: "trademark_name",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "Application No.",
          value: "app_no",
          class: "bg-colorth",
          divider: true,
          width: "14%",
        },
        {
          text: "Receive Date",
          value: "receive_date",
          class: "bg-colorth",
          divider: true,
          width: "104px",
        },
        {
          text: "Deadline Date",
          value: "enddate",
          class: "bg-colorth",
          divider: true,
          width: "104px",
        },
        {
          text: "Internal Date",
          value: "internaldate",
          class: "bg-colorth",
          divider: true,
          width: "104px",
        },
        {
          text: "Title",
          value: "title",
          class: "bg-colorth",
          divider: true,
          width: "13%",
        },
        {
          text: "Remark",
          value: "remark",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "",
          value: "actions",
          width: "15%",
          align: "left",
          divider: true,
        },
        {
          text: "",
          value: "actions",
          align: "start",
          class: "bg-colorth",
          divider: true,
          width: "150px",
        },
      ],
      dialogAdd: false,
      pageSize: 3,
      pageSizes: [3, 6, 9],
      pageCount: 0,
      itemsPerPage: 100,
      load_bg: false,
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      showprint: "display:none;",
      print_data: {},
      previewimageedit: null,
      master_status: 0,
      patent_status_list: [
        {
          patent_status_name: "Nil (Unrecognised Status)",
          patent_status_id: 1,
        },
        { patent_status_name: "Pending", patent_status_id: 2 },
        { patent_status_name: "Registered", patent_status_id: 3 },
        { patent_status_name: "Renewal Pending", patent_status_id: 5 },
        { patent_status_name: "Closed", patent_status_id: 6 },
      ],
    };
  },
  methods: {
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      try {
        // console.log(`start loaddataPagination api.getMasterPTSearchPagination`);

        const result = await api.getMasterPTSearchPagination(
          1,
          this.itemsPerPage,
          "masterpt_id",
          "ASC",
          this.search_pt,
          this.master_status,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        // console.log(
        //   `loaddataPagination result.data:`,
        //   JSON.stringify(result.data)
        // );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalItems;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.itemsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      var sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        if (options.sortBy[0]) {
          sortDesc = "DESC";
        } else {
          sortDesc = "ASC";
        }
      }
      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }
      try {
        const result = await api.getMasterPTSearchPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.search_pt,
          this.master_status,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalItems;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.itemsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      try {
        // console.log(`start loadDataByPage api.getMasterPTSearchPagination`);

        const result = await api.getMasterPTSearchPagination(
          pageNumber,
          this.itemsPerPage,
          "masterpt_id",
          "ASC",
          this.search_pt,
          this.master_status,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );
        // console.log(`loadDataByPage result.data:`, JSON.stringify(result.data));

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalItems;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.itemsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.options.sortBy = [];
      this.options.sortDesc = [];
      this.tableLoading = true;

      if (
        !this.master_status ||
        this.master_status == "" ||
        this.master_status == "null"
      ) {
        this.master_status = 0;
      }

      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "next_annuity_date",
        sortDesc: "ASC",
        search_pt: this.search_pt,
        master_status: this.master_status,
        searchdatefrom: this.searchdatefromPicker,
        searchdateto: this.searchdatetoPicker,
      };
      try {
        // console.log(`start onSearchPagination api.getMasterPTSearchPagination`);

        const result = await api.getMasterPTSearchPagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortDesc,
          s_data.search_pt,
          s_data.master_status,
          s_data.searchdatefrom,
          s_data.searchdateto
        );

        // console.log(
        //   `onSearchPagination result.data:`,
        //   JSON.stringify(result.data)
        // );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalItems;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.itemsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async openPrintAppNo(item) {
      this.$showLoader();
      this.print_data = {};
      this.previewimageedit = null;
      const res_pt = await api.printPT(item.masterpt_id);
      this.print_data = res_pt.data[0];
      console.log(this.print_data);

      var dataAdd = {
        user_id: localStorage.getItem(server.USER_ID),
        log_in_out_id: localStorage.getItem(server.LOGIN_ID),
        action: "Export",
        table_name: "masterpt",
        table_id: item.masterpt_id,
        date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };

      await api.addTransectionLog(dataAdd);

      var dataEditLog = {
        last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };
      await api.updateLogInOutLog(
        localStorage.getItem(server.LOGIN_ID),
        dataEditLog
      );

      setTimeout(async () => {
        await this.exportToPDF();
        this.$hideLoader();
      }, "2000");
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    editItemtimeline(item) {
      const url = `/appointment-patent-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async openeditTableAppointment(appointment_id) {
      window.open(`/appointment-patent-edit/${appointment_id}`);
    },
    async loaddataLimit200() {
      // this.$showLoader();
      var tmp = [];
      const result = await api.getAllMasterPTLimit200();
      tmp = result.data;
      this.mDataArray = tmp;
    },
    async loaddata() {
      // this.$showLoader();
      this.load_bg = true;
      var tmp = [];
      const result = await api.getAllMasterPT();
      tmp = result.data;
      this.mDataArray = this.mDataArray.concat(tmp);
      this.load_bg = false;
    },
    async openeditItem(masterpt_id) {
      // this.$router.push(`/master-patent-edit/${masterpt_id}`);
      window.open(`/master-patent-edit-new/${masterpt_id}`);
    },
    async openeAppoinmentList(file_no) {
      const result = await api.getfile_noPT(file_no);
      console.log(result.data);
      if (result.data) {
        this.mDataArraypopup = result.data;
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Show data ",
          "Data not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.dialogShow = true;
      this.ShowfileNO = file_no;
    },
    async loadTimeline(masterpt_id, file_no) {
      this.showtimelineData = [];

      this.ShowfileNO = file_no;
      this.$showLoader();
      const result = await api.gettimelinemasterpt({
        masterpt_id: masterpt_id,
      });
      if (result.data.length > 0) {
        result.data.forEach((x, i) => {
          const isAnnuity = (x.documenttype_code || "").includes(
            "Annuity Fees"
          );

          if (isAnnuity) {
            x.show_date = `Last Annuity Payment - ${x.last_annuity} (Year)`;
            x.date_sort = x.last_annuity;
          } else if (x.documenttype_code === "New Filing") {
            x.show_date = `Application Date - ${x.application_date}`;
            x.date_sort = x.application_date;
          } else {
            x.show_date = `Submitted Date - ${x.submit_date}`;
            x.date_sort = x.submit_date;
          }

          this.showtimelineData.push(x);

          // parse JSON ก่อน แล้วเช็กว่ามีข้อมูลจริง
          let changeData = Array.isArray(x.change_master_record_data_All)
            ? x.change_master_record_data_All
            : [];

          if (changeData.length > 0) {
            x.documenttype_code =
              changeData.map((item) => item.field_name).join(" / ") || "";
          }
          this.showtimelineData.sort((a, b) => {
            const aIsAnnuity = (a.documenttype_code || "").includes(
              "Annuity Fees"
            );
            const bIsAnnuity = (b.documenttype_code || "").includes(
              "Annuity Fees"
            );

            // กลุ่ม if มาก่อน else
            if (aIsAnnuity && !bIsAnnuity) return -1;
            if (!aIsAnnuity && bIsAnnuity) return 1;

            // ถ้าอยู่ในกลุ่มเดียวกัน
            if (aIsAnnuity) {
              // เรียงตามตัวเลขมากไปน้อย
              return Number(b.date_sort) - Number(a.date_sort);
            } else {
              // แปลงวันที่ dd/mm/yyyy เป็น Date object แล้วเรียงมากไปน้อย
              const parseDate = (d) => {
                if (!d || typeof d !== "string") return new Date(0); // ถ้า null, undefined, หรือไม่ใช่ string ให้เป็นวันที่ต่ำสุด
                const parts = d.split("/");
                if (parts.length !== 3) return new Date(0); // ถ้ารูปแบบไม่ถูกต้อง
                const [day, month, year] = parts.map(Number);
                return new Date(year, month - 1, day);
              };
              return parseDate(b.date_sort) - parseDate(a.date_sort);
            }
          });
          // this.showtimelineData
        });
        if (
          !this.showtimelineData[0].documenttype_code &&
          this.showtimelineData.length == 1
        ) {
          this.showtimelineData = [];
        }
        // result.data.forEach((x, i) => {
        //   this.timelineData.push(x);
        //   if (JSON.parse(x.change_master_record_data_All).length > 0) {
        //     x.documenttype_code = "";
        //     x.documenttype_code =
        //       JSON.parse(x.change_master_record_data_All)
        //         ?.map((item) => item.field_name)
        //         .join(" / ") || "";
        //   }
        // });

        this.$hideLoader();
        this.dialogtimeline = true;
      } else {
        this.$hideLoader();
        Swal.fire({
          icon: "warning",
          title: "ไม่มีข้อมูล",
          text: "ไม่มีข้อมูล Patent Docket",
          showConfirmButton: false, // ❌ ไม่แสดงปุ่ม OK
          timer: 1000, // ⏱ แสดง 2 วินาทีแล้วปิดเอง
          timerProgressBar: true, // แถบเวลานับถอยหลัง (optional)
        });
        return;
      }
    },
    async openeAppoinmentOperation(file_no) {
      this.$router.push(`/appointment-patent-new/${file_no}`);
    },
    async openeAppoinmentOperationforClosed(file_no, masterpt_id) {
      this.dataupdatestatusmasterpt_id = masterpt_id;
      this.dialogAppoinmentOperationforClosed = true;
    },
    async AppoinmentOperationforClosedconfirmstatus() {
      //status 2= Pending
      this.$showLoader();
      const result = await api.updateMasterPt(
        this.dataupdatestatusmasterpt_id,
        { status: 2 }
      );
      if (result.status == 200 || result.status == 201) {
        await this.onSearchPagination();
        this.dialogAppoinmentOperationforClosed = false;
        this.$store.state.global_dialog = true;
        this.$hideLoader();
        this.setupAlertDialog(
          true,
          "Success",
          "Update Status success",
          "text-h5 green--text text-center"
        );
        return;
      } else {
        this.dialogAppoinmentOperationforClosed = false;
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update Status Failed",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async closedialogShow() {
      this.dialogShow = false;
    },
    async onSearch() {
      if (!this.master_status) {
        this.master_status = 0;
      }
      if (this.search_pt.trim() == "" && this.master_status == 0) {
        this.$showLoader();
        await this.loaddataLimit200();
        this.$hideLoader();
      } else {
        this.$showLoader();
        const result = await api.getMasterPTSearch({
          params: {
            search_pt: this.search_pt.trim(),
            master_status: Number(this.master_status),
          },
        });
        this.mDataArray = result.data;
        this.$hideLoader();
      }
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.widthsizesearch {
  width: 70%;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.heightsizesearch {
  height: 45%;
}

.heightsizeformadvance {
  height: 0px;
}

body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "EscrowCond-Roman";
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  font-family: "EscrowCond-Roman";
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "EscrowCond-Roman";
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "EscrowCond-Roman";
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "EscrowCond-Roman";
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width98 {
  word-wrap: break-word;
  width: 98%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 12px;
}

.fontsize14 {
  font-size: 14px;
}

.borderwidththin {
  border-width: thin;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}

.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}

.ml170-prpo {
  margin-left: -170px !important;
}

.mr95prpo {
  margin-right: 95px !important;
}

.ml95prpo {
  margin-left: 95px !important;
}

.mr80prpo {
  margin-right: 80px !important;
}

.ml80prpo {
  margin-left: 80px !important;
}

.mr120prpo {
  margin-right: 120px !important;
}

.ml120prpo {
  margin-left: 120px !important;
}

.showdefaultunderline {
  /* display: table-cell;
  border-bottom: 1px solid black; */
  font-weight: bold;
  text-decoration: underline;
}

.ml10-prpo {
  margin-left: -10px !important;
}

.mr10-prpo {
  margin-right: -10px !important;
}

.ml20-prpo {
  margin-left: -20px !important;
}

.mr20-prpo {
  margin-right: -20px !important;
}

.mr30-prpo {
  margin-right: -30px !important;
}

.ml30-prpo {
  margin-left: -30px !important;
}
</style>
